"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const ITEMS = '[role="menuitem"]:not(:disabled)'

/* Rev 29 Y4: a button that opens a menu of real menuitem buttons, shared by
 * the Send split button and the Scheduled control. The menu opens on its
 * first enabled item (ArrowUp: its last); arrows move and wrap, Home/End
 * jump, Escape closes it back to the button, and Tab or a click outside
 * closes it. With no enabled item, the menu itself takes focus, so Escape
 * and Tab still reach it (review R800-47). */
const useMenuButton = ({ isDisabled = false, refocusKey } = {}) => {
  const [openAt, setOpenAt] = _react.useState(null)
  const isOpen = !!openAt && !isDisabled
  const rootRef = _react.useRef(null)
  const triggerRef = _react.useRef(null)
  const menuRef = _react.useRef(null)
  const menuId = _react.useId.call(void 0, )

  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const onDocumentClick = (e) => {
        if (!_optionalChain([rootRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(e.target )])) setOpenAt(null)
      }
      document.addEventListener('mousedown', onDocumentClick)
      return () => document.removeEventListener('mousedown', onDocumentClick)
    },
    [isOpen],
  )
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const items = _optionalChain([menuRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.querySelectorAll, 'call', _6 => _6(ITEMS)])
      const item = _optionalChain([items, 'optionalAccess', _7 => _7[openAt === 'last' ? items.length - 1 : 0]])
      ;_optionalChain([(_nullishCoalesce(item, () => ( menuRef.current))), 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
    },
    // A change of refocusKey (say, items enabled) moves focus again.
    [isOpen, openAt, refocusKey],
  )

  /* Closes the menu; with returnFocus, focus goes back to the button. */
  const close = _react.useCallback.call(void 0, (returnFocus = true) => {
    setOpenAt(null)
    if (returnFocus) _optionalChain([triggerRef, 'access', _10 => _10.current, 'optionalAccess', _11 => _11.focus, 'call', _12 => _12()])
  }, [])

  const onTriggerKeyDown = (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return
    e.preventDefault()
    setOpenAt(e.key === 'ArrowDown' ? 'first' : 'last')
  }

  const onMenuKeyDown = (e) => {
    const items = [..._nullishCoalesce(_optionalChain([menuRef, 'access', _13 => _13.current, 'optionalAccess', _14 => _14.querySelectorAll, 'call', _15 => _15(ITEMS)]), () => ( []))]
    const at = items.indexOf(document.activeElement )
    const move = (i) => {
      e.preventDefault()
      if (items.length) _optionalChain([items, 'access', _16 => _16[(i + items.length) % items.length], 'optionalAccess', _17 => _17.focus, 'call', _18 => _18()])
    }
    if (e.key === 'ArrowDown') move(at + 1)
    else if (e.key === 'ArrowUp') move(at - 1)
    else if (e.key === 'Home') move(0)
    else if (e.key === 'End') move(items.length - 1)
    else if (e.key === 'Escape' || e.key === 'Tab') {
      if (e.key === 'Escape') e.preventDefault()
      close()
    }
  }

  return {
    isOpen,
    close,
    rootRef,
    triggerProps: {
      ref: triggerRef,
      'aria-haspopup': 'menu' ,
      'aria-expanded': isOpen,
      'aria-controls': isOpen ? menuId : undefined,
      onClick: () => setOpenAt(o => o ? null : 'first'),
      onKeyDown: onTriggerKeyDown,
    },
    menuProps: {
      ref: menuRef,
      id: menuId,
      role: 'menu' ,
      tabIndex: -1,
      onKeyDown: onMenuKeyDown,
    },
  }
}

exports. default = useMenuButton
